import React from 'react'
import Input from '../Input/index'
import colors from '../../theme/colors'

export default (props) => (
  <div style={styles.container}>
    <Input {...props} readOnly />
    <div style={styles.operation}>
      / 12 =
    </div>
  </div>
)

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  operation: {
    color: colors.darkGrey,
    fontSize: '12px',
    paddingLeft: '5px',
    minWidth: '37px',
  },
}
